export default {"src":"/_next/static/media/red_file.c199a1b5.svg","height":45,"width":32,"blurWidth":0,"blurHeight":0};